import { render, staticRenderFns } from "./TicketOverview.vue?vue&type=template&id=548c1c1f&scoped=true&"
import script from "./TicketOverview.vue?vue&type=script&lang=js&"
export * from "./TicketOverview.vue?vue&type=script&lang=js&"
import style0 from "./TicketOverview.vue?vue&type=style&index=0&id=548c1c1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548c1c1f",
  null
  
)

export default component.exports